import { render, staticRenderFns } from "./FreestyleCanvasContent.v2.vue?vue&type=template&id=e1feb44a&scoped=true&"
import script from "./FreestyleCanvasContent.v2.vue?vue&type=script&lang=js&"
export * from "./FreestyleCanvasContent.v2.vue?vue&type=script&lang=js&"
import style0 from "./FreestyleCanvasContent.v2.vue?vue&type=style&index=0&id=e1feb44a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1feb44a",
  null
  
)

export default component.exports